import { NextSeo } from "next-seo";
import { useRouter } from "next/router";
import { BlogSeo, createSEOConfig } from "../../utils/seo";
import { formatDisplayDate, formatSEODate } from "../../utils/formatters";

const BlogMeta = ({ meta }) => {
  const router = useRouter();
  if (!meta) {
    console.error("meta not found!");
    return <>Not found</>;
  }

  const formattedPublishDate = formatSEODate(meta.publishDate);

  return (
    <div className="px-4">
      <NextSeo {...createSEOConfig(meta)} />
      <BlogSeo data={meta} />
      <header className="flex flex-col">
        <img src={meta.imageUrl} className="my-4" />
        <h1 className="mt-6 text-4xl font-bold tracking-tight text-zinc-800 sm:text-5xl">
          {meta.title}
        </h1>
        <time
          dateTime={meta.date}
          className="order-first flex items-center justify-between text-base text-zinc-400 "
        >
          <button
            type="button"
            onClick={() => router.back()}
            aria-label="Go back to articles"
            className="group flex h-10 w-10 items-center justify-center rounded-full bg-white shadow-lg shadow-zinc-800/6 ring-1 ring-zinc-900/5 transition"
          >
            <ArrowLeftIcon className="h-4 w-4 stroke-pink-600 transition group-hover:stroke-zinc-700 " />
          </button>
          <div>
            <span className="h-4 w-0.5 rounded-full bg-zinc-200 " />
            <span className="ml-3">
              {" "}
              {formatDisplayDate(formattedPublishDate)} •{" "}
              {meta.readingTime.text}
            </span>
          </div>
        </time>
      </header>
      {meta.tag && (
        <p className="text-drDocBlue text-sm">{meta.tag.toUpperCase()}</p>
      )}
    </div>
  );
};

function ArrowLeftIcon(props) {
  return (
    <svg viewBox="0 0 16 16" fill="none" aria-hidden="true" {...props}>
      <path
        d="M7.25 11.25 3.75 8m0 0 3.5-3.25M3.75 8h8.5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default BlogMeta;
